import { render, staticRenderFns } from "./MaterialMixtureCategoriesSection.vue?vue&type=template&id=a076764c&"
import script from "./MaterialMixtureCategoriesSection.vue?vue&type=script&lang=js&"
export * from "./MaterialMixtureCategoriesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports